import { StylesHeaderVariables } from '~partials/header/UI'

export const global = (theme) => ({
  // Prevent `100vw` causing issues in browsers (and OS) with scrollbars
  body: {
    overflowX: 'hidden',
  },

  //
  // Code blocks
  //
  pre: {
    maxHeight: 500,
  },

  code: {
    wordBreak: 'break-all',
  },

  '.has-stickyHeader': {
    'h1, h2, h3, h4': {
      scrollMarginTop: StylesHeaderVariables(theme).height,
    },
  },

  //
  // Gatsby
  //

  // Gatsby-contained code block spacing
  '.gatsby-highlight': {
    '& + &': {
      marginTop: theme.space.base,
    },

    '* &': {
      marginTop: theme.space.base,
    },
  },

  // Figcaptions
  '.gatsby-resp-image-figcaption': {
    marginTop: theme.space.small,
    textAlign: 'center',
    ...theme.text.small,
  },

  // Images
  '.gatsby-resp-image-wrapper': {
    '* + &': {
      marginTop: theme.space.base,
    },
  },
})
